import React, { useState, useEffect } from "react";
//import { Button, Form, Alert } from "react-bootstrap";
import {connect, useSelector} from 'react-redux';
import { Redirect } from 'react-router-dom';
//import Card from 'react-bootstrap/Card';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@mui/material/Avatar';
import Divider from '@material-ui/core/Divider';
//import Container from 'react-bootstrap/Container';
import Container from '@material-ui/core/Container';
import TextField from '@material-ui/core/TextField';
import Typography from '@mui/material/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@mui/material/InputAdornment';
import AccountCircle from '@mui/icons-material/AccountCircle';
import LockIcon from '@mui/icons-material/Lock';
import InputIcon from '@mui/icons-material/Input';
import ChevronRight from '@mui/icons-material/ChevronRight';
import ReCAPTCHA from "react-google-recaptcha";
import * as actions from '../store/actions/index';
import * as actionTypes from '../store/actions/actionTypes';


import "./Login.css";
import {makeStyles} from "@material-ui/core/styles/index";

const useStyles = makeStyles(theme => ({

    header: {
        textAlign: 'center',
        spacing: 10,
    }

}));

function Login(props) {
    const classes = useStyles();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [captcha, setCaptcha] = useState("");

    const paperStyle = {padding: 20}

    useEffect(() => {
        if (props.errorAuth){
            var errorMessage = '' + props.errorAuth;
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        }
    }, [props.errorAuth]);

    function validateForm() {
        return email.length > 0 && password.length > 0;
    }

    function onChange(value) {
        //console.log("Captcha value:", value)
        setCaptcha(value);
    }

    function handleSubmit(event) {
        event.preventDefault();
        //console.log("email", email);
        //console.log("password", password);
        //console.log("captcha", captcha);
        props.onAuth(email, password, captcha);
    }


    let authRedirect = null;

    if (props.isAuthenticated){

        authRedirect = <Redirect to="/" />
    }

    // let errorDisplay = null;
    // if (props.errorAuth){
    //     //errorDisplay = <Alert variant='danger'>{props.errorAuth}</Alert>
    //     props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: props.errorAuth});
    // }
    //className="Login"
    //<Divider variant="middle" />
    //className={classes.header}
    //<form onSubmit={handleSubmit}>
    //<!-- /form -->
    return (
        <div>
            {authRedirect}
            <Container maxWidth="xs">
            <Paper elevation={10} style={paperStyle}>
                <Grid align="center">
                    <Avatar sx={{ width: 80, height: 80, mb: 2.5 }}>
                        <InputIcon style={{ fontSize: 50 }}/>
                    </Avatar>
                    <Typography sx={{fontSize: 17}} component="div">
                        Login to your account
                    </Typography>
                    <Typography sx={{ mb: 3.5, fontSize: 13 }} color="text.secondary">
                        Enter your credentials below
                    </Typography>
                </Grid>
                <form onSubmit={handleSubmit}>
                    <Grid container direction={"column"} spacing={3}>
                        <Grid item>
                            <TextField
                                id="email"
                                label="Login name"
                                variant="standard"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <AccountCircle />
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{p: 5}}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="password"
                                label="Password"
                                type="password"
                                variant="standard"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <LockIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid item align="center">
                            <ReCAPTCHA
                                sitekey="6LezG4sUAAAAANeC4nab_zDxP0GgUJEXkVn-DKfM"
                                theme="light"
                                onChange={onChange}
                            />
                        </Grid>
                        <Grid item>
                            <Button
                                block
                                disabled={!validateForm()}
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                endIcon={<ChevronRight />}
                            >
                                Sign In
                            </Button>
                        </Grid>
                    </Grid>
                </form>

            </Paper>
            </Container>
        </div>
    );
}

const mapDispatchToProps = dispatch  => {
    return {
        onAuth: (email, password, captcha) => dispatch(actions.auth(email, password, captcha)),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message))
    }
};

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null,
        errorAuth: state.auth.error
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);